import { render, staticRenderFns } from "./downloadDetail.vue?vue&type=template&id=414dec36&scoped=true"
import script from "./downloadDetail.vue?vue&type=script&lang=js"
export * from "./downloadDetail.vue?vue&type=script&lang=js"
import style0 from "./downloadDetail.vue?vue&type=style&index=0&id=414dec36&prod&scoped=true&lang=less"
import style1 from "./downloadDetail.vue?vue&type=style&index=1&id=414dec36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414dec36",
  null
  
)

export default component.exports